import createAPI from "@/common/createApi.js"
/**
 * config: 接口参数，
 * vconfig: （自定义参数）{
 *  neverLoading: 是否显示loading
 * }
 */
export default {
  // 获取企业应用列表(包含有效期)
  getBruteForceDetection: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/bruteForceDetection`, "get", config),
  // 获取应用api列表
  putBruteForceDetection: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/bruteForceDetection`, "put", config),
    // 获取企业应用列表(包含有效期)
  getsessionLimit: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/sessionLimit`, "get", config),
  // 获取应用api列表
  putsessionLimit: (realmName, config) =>
    createAPI(`/idaas/admin/realms/${ realmName }/sessionLimit`, "put", config),
}
